// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/card-backgrounds/cardbg-static-01.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/card-backgrounds/cardbg-18.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/card-backgrounds/cardbg-19.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/card-backgrounds/cardbg-20.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/card-backgrounds/cardbg-21.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/card-backgrounds/cardbg-static-03.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/store-goose.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/pirate-character.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  /* font-family: "IBM Plex Mono", monospace; */
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  margin: 0;
  padding: 0;
  user-select: none;
  -webkit-user-select: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

::-webkit-scrollbar {
  width: 0;
}
li {
  list-style: none;
}

body {
  color: #fff;
  background-color: #141414;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
}
button {
  border: none;
  padding: 0;
  cursor: pointer;
}

header {
  display: flex;
  justify-content: space-between;
  height: 7vh;
  align-items: center;
  padding: 0 10px;
  width: 100vw;
  max-width: 500px;
}
h6 {
  text-transform: uppercase;
}
.loot-text {
  display: flex;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
  color: yellow;
}
.loot-text::before {
  content: "";
  position: relative;
  width: 48px;
  height: 2px;
  transform: translateY(16px);
  margin-right: 12px;
  background-color: rgba(255, 255, 255, 0.5);
}
.loot-text::after {
  content: "";
  position: relative;
  width: 48px;
  height: 2px;
  transform: translateY(16px);
  margin-left: 12px;
  background-color: rgba(255, 255, 255, 0.5);
}

.toggle-game-container {
  min-width: 48px;
  height: 32px;
  background-color: #000000;
  border-radius: 16px;
  display: flex;
  align-items: center;
  padding: 0 4px;
}
.toggle-game-circle {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: #ff6739;
  transition: 0.2s ease;
}

.refresh-button-container {
  z-index: 1;
  background-color: rgb(31, 31, 31);
  align-self: center;
  color: #ebebeb;
  width: fit-content;
  align-self: flex-end;
  padding: 10px;
  border: 1px solid;
  border-color: rgba(56, 56, 56, 0.5);
  display: flex;
  justify-content: center;
  border-radius: 7px;
}

.refresh-button-container:disabled {
  background-color: rgb(8, 8, 8);
  color: #2e2e2e;
}

particle {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  background-repeat: no-repeat;
  background-size: contain;
}

.app {
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 97vw;
  max-width: 500px;
  animation: appShow 0.1s ease;
}

@keyframes appShow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.main-ui {
  display: flex;
  flex-direction: column;
  height: 65vh;
}

/* .header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  align-items: center;
  height: 5vh;
} */

.logo-text {
  display: flex;
  padding-left: 10px;
  color: #757575;
  font-size: 14px;
  font-weight: 500;
}

.current-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 5px;
  background-color: #050505;
  border-radius: 20px;
  width: 100%;
  aspect-ratio: 1/1;
  overflow: hidden;
  background-size: 400px;
  background-repeat: repeat;
  background-position: 0px 0;
  animation: bg-move 5s linear infinite;
  /* box-shadow: inset 0 0 24px 12px rgba(0, 0, 0, 0.4); */
  border: 4px solid rgba(0, 0, 0, 0.7);
  margin-bottom: 8px;
}
.bg-image-00 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  animation: none;
}

.bg-image-01 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  animation: none;
}
.bg-image-02 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  animation: none;
}

.bg-image-03 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  animation: none;
}

.bg-image-04 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  animation: none;
}
.bg-image-05 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  animation: none;
}

.aura-rarity {
  position: relative;
  display: flex;
  width: fit-content;
  color: black;
  background-color: white;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  padding: 5px 0;
  padding-left: 16px;
  padding-right: 7px;

  border-radius: 4px 0px 0px 24px;
}

.main-aura-panel-container {
  position: absolute;
  bottom: 2%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.main-aura-panel {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  width: 96%;
}

@keyframes bg-move {
  0% {
    background-position: 0px 0;
  }
  100% {
    background-position: 0px 400px;
  }
}

.current-name-container {
  display: flex;
  margin: 5px 0;
  padding: 3px 4px;
  align-items: center;
  width: 100%;
  height: 36px;
  background-size: 120%;
  background-position: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  transition: 0.5s ease;
}

.current-name {
  font-size: 18px;
  font-weight: 600;
  width: 100%;
  color: #000;
  text-align: start;

  padding: 5px 10px;
}
.current-rarity {
  background-color: #000000;
  border-radius: 18px;
  padding: 5px 14px;
  font-size: 15px;
  font-weight: 700;
}

.current-name-container:after {
  content: "";
  display: block;
  width: 50px;
  height: 200px;
  margin-left: 50px;
  background: #fff;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.664) 50%,
    rgba(255, 255, 255, 0.2) 100%
  );
  left: 110%;
  top: -100px;
  z-index: 1;
  transform: rotate(45deg);
  position: absolute;
  animation: movingFlare 10s ease 5s infinite;
}

@keyframes movingFlare {
  0% {
    left: -30px;
    margin-left: 0px;
  }
  8% {
    left: 110%;
    margin-left: 80px;
  }
  100% {
    left: 110%;
    margin-left: 80px;
  }
}

.player-name {
  background-color: #1f1f1f;
  color: #7a7a7a;
  align-self: center;
  width: fit-content;
  padding: 5px 15px;
  height: 32px;
  border: 1px solid;
  border-color: rgba(56, 56, 56, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  z-index: 1;
  transition: background-color 0.2s ease;
  transition: color 0.2s ease;
}
.current-element {
  align-self: center;
  display: flex;
  justify-content: center;
  z-index: 4;
}

.spin-table-container {
  justify-content: space-between;
  position: absolute;
  bottom: 8px;
  width: 97vw;
  height: 22vh;
  max-width: 500px;
  max-height: 180px;
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: #1d1d1d;
  border-radius: 20px;
  z-index: 3;
}
.spin-buttons {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 8px;
  height: 100%;
}

.spin-container {
  display: flex;
  overflow: hidden;
  padding: 20px;
  border-radius: 8px;
  height: 75px;
  background: radial-gradient(
      50% 100% at 50% 100%,
      rgb(144, 163, 255),
      rgba(255, 255, 255, 0) 100%
    ),
    rgb(0, 0, 0);
  background-position: center 70px;
  background-repeat: no-repeat;
  margin-bottom: 30px;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease;
}
.spin-container-glow {
  animation: spin-container-glow 0.2s ease;
  background-position: center 20px;
}

@keyframes spin-container-glow {
  0% {
    background-position: center 70px;
  }
  100% {
    background-position: center 20px;
  }
}

.fade-in {
  animation: 0.2s ease-out slidein;
}

.fade-out {
  animation: 0.1s ease-out fade-out;
}

@keyframes slidein {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}

.spin-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.spin-circle {
  display: flex;
  font-size: 100px;
  justify-content: center;
  align-items: center;
}

.buttons-ui-container {
  justify-content: space-between;
  position: absolute;
  bottom: 8px;
  width: 97vw;
  max-width: 500px;
  max-height: 180px;
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: #1d1d1d;
  border-radius: 20px;
  z-index: 3;
  gap: 8px;
}

.button-ui {
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  height: 56px;
  width: 100%;
  background-color: #a8a8a8;
  color: black;
}

.button-ui:disabled {
  opacity: 0.5;
}

.button-sell {
  transition: scale 0.2s ease-out;
  background-color: #ffc814;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  height: 100%;
  color: #000000e1;
  box-shadow: 0px 0px 0px 0px rgba(247, 182, 3, 0.808);
  transition: box-shadow 0.2s ease;
  padding: 4px;
}

.button-sell:disabled {
  background: #2b2b2b;
  color: #646464;
}

.button-take {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: scale 0.2s ease-out;
  background: linear-gradient(
    90deg,
    rgb(156, 162, 236) 50%,
    rgba(113, 120, 218, 1) 50%,
    rgb(113, 120, 218) 100%
  );
  background-size: 200%;
  background-position: 100% 0;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  height: 100%;
  background-color: #4c6adc;
  color: #000000e1;
  padding: 4px;
}

.button-take:disabled {
  background: #2b2b2b;
  color: #646464;
}

/* .button-spin {
  overflow: hidden;
  width: 100%;
  font-size: 22px;
  font-weight: 500;
  border-radius: 8px;
  padding: 12px 10px;
  background: linear-gradient(
    90deg,
    rgb(255, 103, 57) 50%,
    rgba(255, 61, 0, 1) 50%,
    rgba(255, 61, 0, 1) 50%
  );
  background-size: 200%;
  background-position: 100% 0%;
  color: #000000e1;
  transition: background-position 0.2s ease;
  scale: 1;
} */
.button-spin {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  height: 100%;
  background-color: rgb(223, 223, 223);
  color: #000000;
  scale: 1;
  transition: background-color 0.2s ease;
  padding: 4px;
}
.button-spin:disabled {
  background: #2b2b2b;
  color: #646464;
}

.button-spin-lucky {
  background-color: #22b62e;
  animation: luckyButtonIn 0.2s ease;
}

@keyframes luckyButtonIn {
  0% {
    box-shadow: 0px 0px 12px 24px rgba(72, 247, 3, 0.808);
  }
  100% {
    box-shadow: 0px 0px 0px 0px rgba(72, 247, 3, 0.808);
  }
}

.button-spin-container {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button-spin-size {
  scale: 1.1;
}

.luck-text {
  color: white;
  position: absolute;
  z-index: 1;
  font-size: 24px;
  height: 0px;
}

.black-screen {
  position: absolute;
  display: flex;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}

.top-buttons-bg {
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  -webkit-user-select: none;
          user-select: none;

  height: 36px;
  color: #838383;
  padding: 8px 14px;
  border: 1px solid;
  border-color: rgba(56, 56, 56, 0.5);
  display: flex;
  justify-content: center;
  border-radius: 7px;
}

.top-buttons-bg-open {
  background-color: rgb(0, 0, 0);
  border-color: rgba(100, 100, 100, 0.5);
}

.top-players {
  user-select: none;
  -webkit-user-select: none;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  background: linear-gradient(45deg, #d3b275 33%, #cf752c 46%, #6063f1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #0b2349;
}

.language-button-text {
  user-select: none;
  -webkit-user-select: none;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  color: #707070;
}

.language-button {
  -webkit-user-select: none;
          user-select: none;
  background-color: rgba(0, 0, 0, 0.103);
  align-self: center;
  color: #7a7a7a;
  width: fit-content;
  padding: 5px 15px;
  border: 1px solid;
  border-color: rgba(56, 56, 56, 0.5);
  display: flex;
  justify-content: center;
  border-radius: 7px;
}

.top-players-list {
  background-color: #000000ce;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: rgb(255, 255, 255);
  text-align: left;
  align-self: center;
  position: absolute;
  bottom: 0;
  width: 100vw;
  height: 70vh;
  max-width: 500px;
  z-index: 5;
}

@keyframes show {
  0% {
    opacity: 0;
    bottom: -300px;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
}
.font-2p {
  font-family: "Press Start 2P", system-ui;
}

.upgrade-success-window {
  animation: success-anim 1s;
}

@keyframes success-anim {
  10% {
    background-color: rgb(136, 194, 70);
  }
  20% {
    background-color: black;
  }
  30% {
    background-color: rgb(136, 194, 70);
  }
  40% {
    background-color: black;
  }
  50% {
    background-color: rgb(136, 194, 70);
  }
  60% {
    background-color: black;
  }
}

.upgrade-broken-window {
  animation: broken-anim 1s;
}

@keyframes broken-anim {
  10% {
    background-color: rgb(196, 56, 56);
  }
  20% {
    background-color: black;
  }
  30% {
    background-color: rgb(196, 56, 56);
  }
  40% {
    background-color: black;
  }
  50% {
    background-color: rgb(196, 56, 56);
  }
  60% {
    background-color: black;
  }
}

.top10-header {
  font-family: "Press Start 2P", system-ui;
  display: flex;
  justify-content: center;
  font-weight: 400;
  padding-left: 10px;
  font-size: 14px;
  z-index: 2;
}

.top-player-li {
  z-index: 2;
  font-size: 12px;
  justify-content: space-between;
  border-radius: 8px;
  padding: 8px 12px;
  color: black;
  font-weight: 400;
}

.top-players-you {
  z-index: 2;
  margin-left: 10px;
  background-color: #00000054;
  color: rgba(255, 255, 255, 0.781);
  padding: 0 5px;
  border-radius: 5px;
  font-weight: 500;
}

.aura-container {
  user-select: none;
  -webkit-user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  transition: 0.1s ease;
}

.aura-image {
  user-select: none;
  -webkit-user-select: none;
  display: flex;
  width: 80%;
  transform: translateY(-2px);
  scale: 1;
}

.opacity-0 {
  opacity: 0;
}

@keyframes aura-in {
  0% {
    opacity: 0;
    scale: 0.5;
  }
  100% {
    scale: 1;
    opacity: 1;
  }
}

.tap-circle {
  height: 32px;
  width: 32px;
  align-self: flex-end;
  background-color: orange;
  border-radius: 50%;
}

.settings-container {
  position: absolute;
  background-color: #4c6adc;
  padding: 10px 15px;
  display: flex;
  right: 20px;
  top: 20px;
  border-radius: 7px;
  color: rgb(238, 232, 232);
  font-size: 14px;
  font-weight: 500;
  transform-origin: right;
  animation: showSettings 0.15s ease-out;
}

@keyframes showSettings {
  0% {
    opacity: 0;
    transform: translateY(-100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.bottom-buttons {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  height: 20%;
}
.bottom-item {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  width: 100%;
  height: 100%;
  background-color: #2b2b2b;
  color: #d3d3d3;
}
.bottom-item-clicked {
  background-color: #0a0a0a;
}

.inventory-container {
  background-color: rgba(0, 0, 0, 0.103);
  outline: 1px solid rgba(56, 56, 56, 0.5);
  height: 60vh;
}
.add-ui-container {
  position: relative;
  margin-bottom: 10px;
  border-radius: 20px;
  overflow-y: scroll;
  background-position: center;
  background-size: contain;
}

.inventory-title {
  background-color: rgba(0, 0, 0, 0.103);
  color: rgb(194, 194, 194);
  font-weight: 500;
  outline: 1px solid rgba(56, 56, 56, 0.5);
  padding: 5px 8px;
  border-radius: 20px;
  min-height: 42px;
  margin: 5px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.invenory-title-text {
  margin-left: 10px;
}
.intentory-title-quantity {
  padding: 5px 8px;
  border-radius: 6px;
}
.auras-table {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 10px;
  overflow: hidden;
  padding: 10px;
}

.inventory-table {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  overflow: hidden;
  padding: 10px;
}
.inventory-rarity-circle {
  height: 10px;
  width: 10px;
  top: 7px;
  right: 7px;
  position: absolute;
  border-radius: 6px;
  rotate: -45deg;
}
.table-item {
  border-radius: 12px;
  padding: 4px;
  position: relative;
  background-size: 150%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: inset 0px -30px 40px 0px rgba(37, 37, 37, 0.349);
  border: 2px solid rgba(255, 255, 255, 0.267);
}
.table-item-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  line-height: 1em;
  font-weight: 700;
  height: 35px;
  color: rgba(255, 255, 255, 0.83);
  background-color: #000000e3;
  border-radius: 8px;
  padding: 5px;
  text-align: center;
}
.aura-item-img {
  border-radius: 8px;
  padding-bottom: 14px;
}
.table-item-img {
  border-radius: 8px;
}

.table-item-quantity {
  color: #e2e2e2d5;
  display: flex;
  padding: 5px 8px;
  font-size: 10px;
  border-radius: 6px;
  background-color: #00000094;
}
.table-item-cost {
  display: flex;
  gap: 5px;
  align-items: center;
  color: #f1f1f1d5;
  padding: 2px 5px;
  padding-left: 7px;
  font-size: 10px;
  border-radius: 12px;
  background-color: rgb(0, 0, 0);
}

.active-item-menu {
  display: inline-block;
  justify-content: center;
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: 25px;
}

.active-item-button {
  background-color: #000000e5;
  margin-bottom: 5px;
  border-radius: 5px;
  color: beige;
  width: 100%;
  height: 50px;
}

.active-item-description {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1.2em;
  padding: 12px 12px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 4px;
}

.mini-game-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6); /* Затемнение фона */
  z-index: 10; /* Поверх остальных элементов */
}

.luck-bonus {
  color: rgb(122, 122, 122);
  background-color: rgb(31, 31, 31);
  transition: background-color 0.2s ease;
}

.last-spin {
  background-color: yellowgreen;
  color: black;
  font-weight: 600;
}

.shop-image {
  display: flex;
  padding-top: 20px;
  padding: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  height: 40vh;
  outline: 1px solid rgba(56, 56, 56, 0.5);
  border-radius: 20px;
  background-size: cover;
  margin-bottom: 5px;
  background-position: center;
  font-size: 14px;
}
.pirate-image {
  display: flex;
  padding-top: 20px;
  padding: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  height: 40vh;
  outline: 1px solid rgba(56, 56, 56, 0.5);
  border-radius: 20px;
  background-size: cover;
  margin-bottom: 5px;
  background-position: center;
  font-size: 14px;
}
.shop-dialog {
  text-align: center;
  padding: 10px;
  border-radius: 8px;
  position: relative;
  background-color: white;
  color: #000;
  width: 45%;
  height: fit-content;
  overflow-wrap: break-word;
  white-space: normal;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Для красивого вида */
}

.shop-dialog::after {
  content: "";
  position: absolute;
  top: 30%; /* Расположение выше основного блока */
  right: -5px; /* Смещение вправо */
  rotate: 45deg;
  width: 15px;
  height: 15px;
  background-color: white;
}

.shop-items-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  flex-direction: column;
  padding: 10px;
  font-size: 14px;
  height: 100%;
  gap: 10px;
}

.shop-item-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding: 4px;
  padding-top: 12px;
  position: relative;
  flex-shrink: 0;
  box-shadow: inset 0px 0px 20px 0px rgba(0, 0, 0, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.267);
  background-color: #007866;
  width: 100%;
  border-radius: 8px;
}

.shop-item-img {
  width: 90%;
  border-radius: 4px;
}
.shop-item-title {
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 0.863);
  border-radius: 4px;
  padding: 4px;
  line-height: 1em;
}
.shop-item-price {
  width: 100px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.shop-variants-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.shop-variants {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}
.shop-variants-title {
  width: 30%;
}

.variant-selected {
  outline: 2px solid rgba(255, 255, 255, 0.6);
}
.shop-variant {
  background-color: rgb(31, 31, 31);
  color: #ebebeb;
  align-self: flex-end;
  border: 1px solid;
  border-color: rgba(56, 56, 56, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  padding: 8px;
  min-width: 60px;
}

.buy-confirm-window {
  background-color: #000000fd;
  padding: 20px;
  display: flex;
  flex-direction: column-reverse;
  gap: 0.5rem;
  color: rgb(255, 255, 255);
  text-align: left;
  align-self: center;
  position: absolute;
  bottom: 0;
  width: 100vw;
  max-width: 500px;
  z-index: 4;
}
.buy-confirm-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.buy-buttons {
  background-color: rgb(31, 31, 31);
  color: #ebebeb;
  width: 40px;
  height: 40px;
  align-self: flex-end;
  padding: 10px;
  border: 1px solid;
  border-color: rgba(56, 56, 56, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  font-size: 18px;
}

.button-buy {
  background-color: rgb(113, 120, 218);
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  height: 55px;
  color: #000000e1;
}

.button-buy:disabled {
  background-color: rgb(57, 58, 75);
}

.buy-confirm-quantity {
  width: 40px;
  text-align: center;
}

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  aspect-ratio: 1/1;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #292929;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.potion-container {
  position: relative;
  z-index: 7;
  width: 0;
  height: 0;
}

.potion {
  transition: transform 0.2s ease;
}

.city-block-wrapper {
  display: flex;
  flex-direction: column;
  padding: 10px;
  font-size: 14px;
  height: 100%;
  gap: 10px;
}

.city-block-container {
  display: flex;
  gap: 20px;
  height: 120px;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  padding-right: 20px;
  position: relative;
  flex-shrink: 0;
  box-shadow: inset 0px -30px 40px 0px rgba(37, 37, 37, 0.349);
  background-size: cover;
  background-position: center;
  background-color: #1b1b1b;
  width: 100%;
  border-radius: 8px;
}

.city-block-title {
  opacity: 0.9;
  font-size: 16px;
  color: #e0e0e0dc;
  background-color: #0f0f0f;
  padding: 10px 15px;
  transform: translateY(30px);
  border-radius: 0px 35px 10px 0px;
}

.back-icon {
  margin-right: 10px;
  rotate: 90deg;
}

.city-name {
  font-size: 16px;
  padding: 10px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  letter-spacing: 0.2em;
  text-align: center;
}

.city-name::before {
  content: "";
  position: absolute;
  width: 52px;
  height: 1px;
  transform: translateX(-70px) translateY(9px);
  background-color: rgba(255, 255, 255, 0.4);
}

.city-name::after {
  content: "";
  position: absolute;
  width: 52px;
  height: 1px;
  transform: translateX(10px) translateY(9px);
  background-color: rgba(255, 255, 255, 0.4);
}

.blacksmith-items-wrapper {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 10px;
  overflow: hidden;
  padding: 10px;
}

.blacksmith-item {
  border: 2px solid rgba(255, 255, 255, 0.267);
  border-radius: 12px;
  padding: 4px;
  position: relative;
  flex-shrink: 0;

  background-color: #1a1a1a;
}
.blacksmith-item-img {
  width: 100%;
  border-radius: 8px;
}
.blacksmith-item-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-align: center;
  line-height: 1em;
  padding: 0 10px;
  background-color: #363636bb;
  border-radius: 6px;
  height: 28px;
}
.blacksmith-item-circle {
  position: absolute;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  right: 6px;
  top: 6px;
}

.forge-divider {
  position: absolute;
  width: 100%;
  left: 0;
  top: -10px;
}
.forge-container {
  padding: 12px;
  overflow: scroll;
}

.forge-top-container {
  border-radius: 8px;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    rgb(36, 36, 36) 0%,
    rgba(51, 51, 51, 0.295) 100%
  );
  height: 25%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 6px;
}
.forge-title-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.forge-title {
  font-size: 18px;
  text-align: center;
  max-width: 85%;
  margin-bottom: 10px;
}
.forge-description {
  font-size: 14px;
  color: rgb(140, 207, 95);
  text-align: center;
  max-width: 85%;
}
.forge-image {
  height: 100%;
  border-radius: 8px;
}

.forge-need-wrapper {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  overflow: hidden;
  background-color: #000000;
}

.forge-need-container {
  position: relative;
  background-color: #222222;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  gap: 4px;
  font-size: 10px;
}
.forge-need-img {
  width: 100%;
  border-radius: 6px;
  background-color: #3d3d3d;
}
.forge-need-title {
  text-align: center;
  height: 24px;
  display: flex;
  align-items: center;
}

.add-ui-forge {
  margin-bottom: 20px;
  border-radius: 20px;
  height: 100%;
  overflow: hidden;
}

.forge-item-quantity {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  min-width: 16px;
  padding: 0 4px;
  height: 16px;
  background-color: yellow;
  color: black;
  border-radius: 4px;
}

.forge-button {
  color: "white";
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  gap: 10px;
  color: rgba(22, 22, 22, 0.911);
  overflow: hidden;
  font-size: 18px;
  font-weight: 600;
  padding: 10px 16px;
  margin-top: 24px;
  background-color: yellow;
}

.forge-button:disabled {
  color: "white";
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  gap: 10px;
  color: rgba(22, 22, 22, 0.911);
  overflow: hidden;
  font-size: 18px;
  font-weight: 600;
  padding: 10px 16px;
  margin-top: 24px;
  background-color: rgb(63, 63, 63);
}

.crafting-anim {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
  background-color: #000000e3;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 4;
}

.zoom-item-wrapper {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: fit-content;
  width: 80%;
  max-width: 400px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.zoom-item-container {
  z-index: 5;
  display: flex;
  flex-direction: column;
  position: relative;
  border: #3d3d3d 1px solid;
  border-radius: 12px;
  padding: 16px;
  gap: 10px;
  box-shadow: inset 0px 0 24px 12px rgba(0, 0, 0, 0.3);
  border: 3px solid rgba(0, 0, 0, 0.6);
  animation: glossy 0.2s ease-out;
  margin-bottom: 16px;
}

.zoom-item-container::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.3),
    rgba(0, 0, 0, 0) 70%
  );
  z-index: -1;
}
@keyframes glossy {
  0% {
    box-shadow: inset 0px 0px 5px 0px rgba(255, 255, 255, 0.2);
    transform: rotateX(20deg);
  }
  100% {
    box-shadow: inset 0px 120px 5px 0px rgba(255, 255, 255, 0.2);
    transform: rotateX(00deg);
  }
}

.zoom-item-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 1em;
  font-weight: 600;
  height: 35px;
  padding: 5px 10px;
  text-align: center;
  width: 100%;
}
.zoom-item-description {
  color: yellow;
  background-color: rgba(0, 0, 0, 0.227);
  width: 100%;
  text-align: center;
  padding: 10px 15px;
  border-radius: 6px;
  font-size: 14px;
}

.zoom-item-quantity {
  position: absolute;
  text-align: end;
  color: #e2e2e2d5;
  padding: 5px 8px;
  font-size: 12px;
  border-radius: 6px 6px 0 0;
  background-color: #464646e7;
  top: -26px;
  left: 10px;
}
.zoom-item-rarity {
  position: absolute;
  text-align: end;
  color: #000000;
  padding: 5px 8px;
  font-size: 12px;
  border-radius: 6px 6px 0 0;
  top: -27px;
  right: 10px;
}
.zoom-item-img {
  border-radius: 8px;
  width: 100%;
  margin-bottom: 20px;
  transition: 0.2s ease;
}

.upgrading-img-anim {
  animation: upgrading-scale 3s ease-in-out,
    upgrading-shake 0.2s linear infinite;
}

@keyframes upgrading-scale {
  0% {
    scale: 1;
  }
  95% {
    scale: 0.8;
  }
  100% {
    scale: 1;
  }
}

@keyframes upgrading-shake {
  0% {
    rotate: -3deg;
  }
  25% {
    rotate: 2deg;
  }
  50% {
    rotate: -1deg;
  }
  75% {
    rotate: 4deg;
  }
  100% {
    rotate: 0deg;
  }
}

.zoom-item-button {
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  background-color: rgb(223, 238, 18);
  color: rgb(0, 0, 0);
  padding: 6px 10px;
  z-index: 5;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1em;
  text-align: left;
  height: 48px;
}
.zoom-item-button-center {
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  background-color: rgb(223, 238, 18);
  color: rgb(0, 0, 0);
  padding: 6px 10px;
  z-index: 5;
  width: 100%;
  align-items: center;
  line-height: 1em;
  height: 48px;
}

.zoom-item-button:disabled {
  background-color: #979797;
}

.shimmer {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    #ffffff3d 0%,
    #b8b8b8 25%,
    #ffffff 50%,
    #a8a8a8 75%,
    #ffffff3d 100%
  );
  opacity: 0.3;
  background-size: 200% 100%;
  animation: shimmer 1.5s linear infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.equipped-items-container {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  margin-bottom: 10px;
  padding: 5px;
}
.wearing-text {
  display: flex;
  justify-content: center;
  width: 40%;
  color: #ffffffa4;
}
.equipped-item {
  height: 50px;
  border: 1px solid rgb(48, 48, 48);
  border-radius: 8px;
  aspect-ratio: 1/1;
  background-color: #0000009c;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.623);
  font-weight: 700;
  font-size: 18px;
}

.items-stack-container {
  left: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4px;
  width: 50px;
  top: 15%;
  background-color: #51af34;
  border-radius: 0px 12px 12px 0px;
  border: 2px solid rgba(255, 255, 255, 0.267);
}

.items-stack-quantity {
  font-weight: 600;
  font-size: 12px;
  color: #ffffffe8;
  white-space: nowrap;
}

.button-autospin {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 25%; /* У вас уже указано дважды, оставил один */
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  height: 100%;
  background-color: rgb(223, 223, 223);
  background-size: 200% 100%;
  color: #000000;
  scale: 1;
  transition: background-color 0.2s ease;
}

.gradient-flow {
  background-color: rgb(176, 221, 51);
}

.dungeon-container {
  position: relative;
  margin-bottom: 10px;
  border-radius: 20px;
  background-position: center;
  background-size: contain;
  background-color: rgba(0, 0, 0, 0.103);
  outline: 1px solid rgba(56, 56, 56, 0.5);
  width: 100%;
  aspect-ratio: 1/1;
}

.dropdown-container {
  position: relative;
}

.dropdown {
  padding: 4px 15px;
  font-size: 16px;
  background-color: #3e434d;
  color: #ddd;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  padding-right: 30px; /* Увеличиваем отступ для стрелки */
  appearance: none; /* Убираем стандартную стрелку */
}

.dropdown:focus {
  outline: none;
  background-color: #4a4f5c;
  color: #fff;
}

.dropdown option {
  padding: 10px;
  font-size: 16px;
  background-color: #3e434d;
  color: #ddd;
}

.dropdown option:hover {
  background-color: #4a4f5c;
}

/* Кастомная стрелка */
.dropdown-container::after {
  content: "▼"; /* Стрелка вниз */
  position: absolute;
  right: 10px; /* Отступ от правого края */
  top: 50%;
  transform: translateY(-50%); /* Центрирование по вертикали */
  font-size: 12px;
  color: #ddd;
  pointer-events: none; /* Стрелка не мешает кликам */
}

.request-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(62, 66, 71);
  padding: 4px;
  width: 100%;
  padding-left: 12px;
  border-radius: 12px;
}

.status-text {
  font-size: 12px;
  padding-left: 12px;
  display: flex;
  align-items: center;
}
.online {
  color: rgb(131, 221, 89);
}

.online::before {
  content: "";
  position: absolute;
  transform: translateX(-12px);
  height: 10px;
  width: 10px;
  border-radius: 6px;
  background-color: rgb(131, 221, 89);
}
.offline {
  color: rgb(121, 121, 121);
}
.offline::before {
  content: "";
  position: absolute;
  transform: translateX(-12px);
  height: 10px;
  width: 10px;
  border-radius: 6px;
  background-color: rgb(121, 121, 121);
}

.reward-container {
  position: absolute;
  margin: auto;
  top: 100px;
  left: 0;
  bottom: 0;
  right: 0;
  height: fit-content;
  width: 80%;
  max-width: 400px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgb(108, 56, 192);
  border-radius: 12px;
  padding: 12px;
}

.reward-window {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 10px;
  overflow: hidden;
  padding: 10px;
}
.reward-item-container {
  position: relative;
  background-color: #2b2331;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  gap: 4px;
  font-size: 14px;
  z-index: 3;
}
.reward-today {
  outline: 4px solid rgba(255, 255, 0, 0.829);
}
.reward-img {
  width: 100%;
  aspect-ratio: 1/1;
}

.reward-top-image {
  position: absolute;
  bottom: 75%;
  width: 100%;
  opacity: 1;
  z-index: 1;
  animation: gooseShow 2s ease;
}

@keyframes gooseShow {
  0% {
    bottom: 60%;
    opacity: 0;
  }
  50% {
    bottom: 60%;
    opacity: 0;
  }
  100% {
    bottom: 75%;
    opacity: 1;
  }
}
.reward-backscreen {
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000000c2;
  z-index: 10;
}

.header-text {
  font-size: 18px;
  font-weight: 700;
  color: rgb(255, 238, 0);
  background-color: rgb(36, 36, 36);
  padding: 4px 24px;
  rotate: -3deg;
  margin-bottom: 5px;
  z-index: 2;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,qCAAqC;EACrC,wDAAwD;EACxD,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,yDAAuE;EACvE,eAAe;AACjB;;AAEA;EACE,yDAAgE;EAChE,eAAe;AACjB;AACA;EACE,yDAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,yDAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,yDAAgE;EAChE,eAAe;AACjB;AACA;EACE,yDAAuE;EACvE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;;EAElB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,iBAAiB;;EAEjB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB;;;;;GAKC;EACD,UAAU;EACV,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ;;;;;gBAKc;EACd,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,oDAAoD;EACpD,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B;;;;;GAKC;EACD,qBAAqB;EACrB,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;GAkBG;AACH;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,QAAQ;EACR,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE;IACE,qDAAqD;EACvD;EACA;IACE,mDAAmD;EACrD;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,MAAM;EACN,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;;EAEjB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qEAAqE;EACrE,6BAA6B;EAC7B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,UAAU;IACV,SAAS;EACX;AACF;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,2BAA2B;EAC3B,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,6CAA6C;EAC7C,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4DAA4D;EAC5D,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC,EAAE,oBAAoB;EAC1D,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,yDAAiD;EACjD,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,yDAAsD;EACtD,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC,EAAE,uBAAuB;AACnE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ,EAAE,sCAAsC;EAChD,WAAW,EAAE,oBAAoB;EACjC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qDAAqD;EACrD,4CAA4C;EAC5C,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,iCAAiC;EACjC,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,4DAA4D;EAC5D,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,6CAA6C;EAC7C,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;;EAEd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,UAAU;AACZ;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;;GAIC;EACD,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,oDAAoD;EACpD,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,WAAW;AACb;AACA;EACE;IACE,0DAA0D;IAC1D,yBAAyB;EAC3B;EACA;IACE,4DAA4D;IAC5D,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;wCACsC;AACxC;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB;;;;;;;GAOC;EACD,YAAY;EACZ,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,yBAAyB;EACzB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU,EAAE,2CAA2C;EACvD,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,cAAc;EACd,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,sCAAsC;EACtC,wCAAwC;EACxC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,mBAAmB,EAAE,mCAAmC;EACxD,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,YAAY,EAAE,iBAAiB;EAC/B,kBAAkB;EAClB,WAAW,EAAE,2BAA2B;EACxC,QAAQ;EACR,2BAA2B,EAAE,+BAA+B;EAC5D,eAAe;EACf,WAAW;EACX,oBAAoB,EAAE,6BAA6B;AACrD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,OAAO;EACP,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,6CAA6C;EAC7C,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,UAAU;AACZ;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["* {\n  /* font-family: \"IBM Plex Mono\", monospace; */\n  font-family: \"Exo 2\", sans-serif;\n  font-optical-sizing: auto;\n  font-style: normal;\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  -webkit-user-select: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n}\n\n::-webkit-scrollbar {\n  width: 0;\n}\nli {\n  list-style: none;\n}\n\nbody {\n  color: #fff;\n  background-color: #141414;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-x: hidden;\n}\nbutton {\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\nheader {\n  display: flex;\n  justify-content: space-between;\n  height: 7vh;\n  align-items: center;\n  padding: 0 10px;\n  width: 100vw;\n  max-width: 500px;\n}\nh6 {\n  text-transform: uppercase;\n}\n.loot-text {\n  display: flex;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: yellow;\n}\n.loot-text::before {\n  content: \"\";\n  position: relative;\n  width: 48px;\n  height: 2px;\n  transform: translateY(16px);\n  margin-right: 12px;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.loot-text::after {\n  content: \"\";\n  position: relative;\n  width: 48px;\n  height: 2px;\n  transform: translateY(16px);\n  margin-left: 12px;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.toggle-game-container {\n  min-width: 48px;\n  height: 32px;\n  background-color: #000000;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  padding: 0 4px;\n}\n.toggle-game-circle {\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  background-color: #ff6739;\n  transition: 0.2s ease;\n}\n\n.refresh-button-container {\n  z-index: 1;\n  background-color: rgb(31, 31, 31);\n  align-self: center;\n  color: #ebebeb;\n  width: fit-content;\n  align-self: flex-end;\n  padding: 10px;\n  border: 1px solid;\n  border-color: rgba(56, 56, 56, 0.5);\n  display: flex;\n  justify-content: center;\n  border-radius: 7px;\n}\n\n.refresh-button-container:disabled {\n  background-color: rgb(8, 8, 8);\n  color: #2e2e2e;\n}\n\nparticle {\n  position: fixed;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  width: 97vw;\n  max-width: 500px;\n  animation: appShow 0.1s ease;\n}\n\n@keyframes appShow {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.main-ui {\n  display: flex;\n  flex-direction: column;\n  height: 65vh;\n}\n\n/* .header {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 1rem;\n  align-items: center;\n  height: 5vh;\n} */\n\n.logo-text {\n  display: flex;\n  padding-left: 10px;\n  color: #757575;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.current-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  padding: 5px;\n  background-color: #050505;\n  border-radius: 20px;\n  width: 100%;\n  aspect-ratio: 1/1;\n  overflow: hidden;\n  background-size: 400px;\n  background-repeat: repeat;\n  background-position: 0px 0;\n  animation: bg-move 5s linear infinite;\n  /* box-shadow: inset 0 0 24px 12px rgba(0, 0, 0, 0.4); */\n  border: 4px solid rgba(0, 0, 0, 0.7);\n  margin-bottom: 8px;\n}\n.bg-image-00 {\n  background-image: url(\"/public/card-backgrounds/cardbg-static-01.webp\");\n  animation: none;\n}\n\n.bg-image-01 {\n  background-image: url(\"/public/card-backgrounds/cardbg-18.webp\");\n  animation: none;\n}\n.bg-image-02 {\n  background-image: url(\"/public/card-backgrounds/cardbg-19.webp\");\n  animation: none;\n}\n\n.bg-image-03 {\n  background-image: url(\"/public/card-backgrounds/cardbg-20.webp\");\n  animation: none;\n}\n\n.bg-image-04 {\n  background-image: url(\"/public/card-backgrounds/cardbg-21.webp\");\n  animation: none;\n}\n.bg-image-05 {\n  background-image: url(\"/public/card-backgrounds/cardbg-static-03.webp\");\n  animation: none;\n}\n\n.aura-rarity {\n  position: relative;\n  display: flex;\n  width: fit-content;\n  color: black;\n  background-color: white;\n  font-weight: 700;\n  font-size: 12px;\n  text-transform: uppercase;\n  padding: 5px 0;\n  padding-left: 16px;\n  padding-right: 7px;\n\n  border-radius: 4px 0px 0px 24px;\n}\n\n.main-aura-panel-container {\n  position: absolute;\n  bottom: 2%;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.main-aura-panel {\n  display: flex;\n  gap: 10px;\n  justify-content: space-between;\n  align-items: center;\n  width: 96%;\n}\n\n@keyframes bg-move {\n  0% {\n    background-position: 0px 0;\n  }\n  100% {\n    background-position: 0px 400px;\n  }\n}\n\n.current-name-container {\n  display: flex;\n  margin: 5px 0;\n  padding: 3px 4px;\n  align-items: center;\n  width: 100%;\n  height: 36px;\n  background-size: 120%;\n  background-position: center;\n  justify-content: space-between;\n  position: relative;\n  overflow: hidden;\n  border-radius: 18px;\n  transition: 0.5s ease;\n}\n\n.current-name {\n  font-size: 18px;\n  font-weight: 600;\n  width: 100%;\n  color: #000;\n  text-align: start;\n\n  padding: 5px 10px;\n}\n.current-rarity {\n  background-color: #000000;\n  border-radius: 18px;\n  padding: 5px 14px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.current-name-container:after {\n  content: \"\";\n  display: block;\n  width: 50px;\n  height: 200px;\n  margin-left: 50px;\n  background: #fff;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.2) 0%,\n    rgba(255, 255, 255, 0.664) 50%,\n    rgba(255, 255, 255, 0.2) 100%\n  );\n  left: 110%;\n  top: -100px;\n  z-index: 1;\n  transform: rotate(45deg);\n  position: absolute;\n  animation: movingFlare 10s ease 5s infinite;\n}\n\n@keyframes movingFlare {\n  0% {\n    left: -30px;\n    margin-left: 0px;\n  }\n  8% {\n    left: 110%;\n    margin-left: 80px;\n  }\n  100% {\n    left: 110%;\n    margin-left: 80px;\n  }\n}\n\n.player-name {\n  background-color: #1f1f1f;\n  color: #7a7a7a;\n  align-self: center;\n  width: fit-content;\n  padding: 5px 15px;\n  height: 32px;\n  border: 1px solid;\n  border-color: rgba(56, 56, 56, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  z-index: 1;\n  transition: background-color 0.2s ease;\n  transition: color 0.2s ease;\n}\n.current-element {\n  align-self: center;\n  display: flex;\n  justify-content: center;\n  z-index: 4;\n}\n\n.spin-table-container {\n  justify-content: space-between;\n  position: absolute;\n  bottom: 8px;\n  width: 97vw;\n  height: 22vh;\n  max-width: 500px;\n  max-height: 180px;\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  background-color: #1d1d1d;\n  border-radius: 20px;\n  z-index: 3;\n}\n.spin-buttons {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: 8px;\n  height: 100%;\n}\n\n.spin-container {\n  display: flex;\n  overflow: hidden;\n  padding: 20px;\n  border-radius: 8px;\n  height: 75px;\n  background: radial-gradient(\n      50% 100% at 50% 100%,\n      rgb(144, 163, 255),\n      rgba(255, 255, 255, 0) 100%\n    ),\n    rgb(0, 0, 0);\n  background-position: center 70px;\n  background-repeat: no-repeat;\n  margin-bottom: 30px;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.2s ease;\n}\n.spin-container-glow {\n  animation: spin-container-glow 0.2s ease;\n  background-position: center 20px;\n}\n\n@keyframes spin-container-glow {\n  0% {\n    background-position: center 70px;\n  }\n  100% {\n    background-position: center 20px;\n  }\n}\n\n.fade-in {\n  animation: 0.2s ease-out slidein;\n}\n\n.fade-out {\n  animation: 0.1s ease-out fade-out;\n}\n\n@keyframes slidein {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n@keyframes fade-out {\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n}\n\n.spin-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spin-circle {\n  display: flex;\n  font-size: 100px;\n  justify-content: center;\n  align-items: center;\n}\n\n.buttons-ui-container {\n  justify-content: space-between;\n  position: absolute;\n  bottom: 8px;\n  width: 97vw;\n  max-width: 500px;\n  max-height: 180px;\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  background-color: #1d1d1d;\n  border-radius: 20px;\n  z-index: 3;\n  gap: 8px;\n}\n\n.button-ui {\n  font-size: 18px;\n  font-weight: 500;\n  border-radius: 8px;\n  height: 56px;\n  width: 100%;\n  background-color: #a8a8a8;\n  color: black;\n}\n\n.button-ui:disabled {\n  opacity: 0.5;\n}\n\n.button-sell {\n  transition: scale 0.2s ease-out;\n  background-color: #ffc814;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 500;\n  border-radius: 8px;\n  height: 100%;\n  color: #000000e1;\n  box-shadow: 0px 0px 0px 0px rgba(247, 182, 3, 0.808);\n  transition: box-shadow 0.2s ease;\n  padding: 4px;\n}\n\n.button-sell:disabled {\n  background: #2b2b2b;\n  color: #646464;\n}\n\n.button-take {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: scale 0.2s ease-out;\n  background: linear-gradient(\n    90deg,\n    rgb(156, 162, 236) 50%,\n    rgba(113, 120, 218, 1) 50%,\n    rgb(113, 120, 218) 100%\n  );\n  background-size: 200%;\n  background-position: 100% 0;\n  width: 100%;\n  font-size: 18px;\n  font-weight: 500;\n  border-radius: 8px;\n  height: 100%;\n  background-color: #4c6adc;\n  color: #000000e1;\n  padding: 4px;\n}\n\n.button-take:disabled {\n  background: #2b2b2b;\n  color: #646464;\n}\n\n/* .button-spin {\n  overflow: hidden;\n  width: 100%;\n  font-size: 22px;\n  font-weight: 500;\n  border-radius: 8px;\n  padding: 12px 10px;\n  background: linear-gradient(\n    90deg,\n    rgb(255, 103, 57) 50%,\n    rgba(255, 61, 0, 1) 50%,\n    rgba(255, 61, 0, 1) 50%\n  );\n  background-size: 200%;\n  background-position: 100% 0%;\n  color: #000000e1;\n  transition: background-position 0.2s ease;\n  scale: 1;\n} */\n.button-spin {\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n  font-size: 18px;\n  font-weight: 500;\n  border-radius: 8px;\n  height: 100%;\n  background-color: rgb(223, 223, 223);\n  color: #000000;\n  scale: 1;\n  transition: background-color 0.2s ease;\n  padding: 4px;\n}\n.button-spin:disabled {\n  background: #2b2b2b;\n  color: #646464;\n}\n\n.button-spin-lucky {\n  background-color: #22b62e;\n  animation: luckyButtonIn 0.2s ease;\n}\n\n@keyframes luckyButtonIn {\n  0% {\n    box-shadow: 0px 0px 12px 24px rgba(72, 247, 3, 0.808);\n  }\n  100% {\n    box-shadow: 0px 0px 0px 0px rgba(72, 247, 3, 0.808);\n  }\n}\n\n.button-spin-container {\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.button-spin-size {\n  scale: 1.1;\n}\n\n.luck-text {\n  color: white;\n  position: absolute;\n  z-index: 1;\n  font-size: 24px;\n  height: 0px;\n}\n\n.black-screen {\n  position: absolute;\n  display: flex;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1;\n}\n\n.top-buttons-bg {\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n  user-select: none;\n\n  height: 36px;\n  color: #838383;\n  padding: 8px 14px;\n  border: 1px solid;\n  border-color: rgba(56, 56, 56, 0.5);\n  display: flex;\n  justify-content: center;\n  border-radius: 7px;\n}\n\n.top-buttons-bg-open {\n  background-color: rgb(0, 0, 0);\n  border-color: rgba(100, 100, 100, 0.5);\n}\n\n.top-players {\n  user-select: none;\n  -webkit-user-select: none;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  background: linear-gradient(45deg, #d3b275 33%, #cf752c 46%, #6063f1);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: #0b2349;\n}\n\n.language-button-text {\n  user-select: none;\n  -webkit-user-select: none;\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #707070;\n}\n\n.language-button {\n  user-select: none;\n  background-color: rgba(0, 0, 0, 0.103);\n  align-self: center;\n  color: #7a7a7a;\n  width: fit-content;\n  padding: 5px 15px;\n  border: 1px solid;\n  border-color: rgba(56, 56, 56, 0.5);\n  display: flex;\n  justify-content: center;\n  border-radius: 7px;\n}\n\n.top-players-list {\n  background-color: #000000ce;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  color: rgb(255, 255, 255);\n  text-align: left;\n  align-self: center;\n  position: absolute;\n  bottom: 0;\n  width: 100vw;\n  height: 70vh;\n  max-width: 500px;\n  z-index: 5;\n}\n\n@keyframes show {\n  0% {\n    opacity: 0;\n    bottom: -300px;\n  }\n  100% {\n    opacity: 1;\n    bottom: 0;\n  }\n}\n.font-2p {\n  font-family: \"Press Start 2P\", system-ui;\n}\n\n.upgrade-success-window {\n  animation: success-anim 1s;\n}\n\n@keyframes success-anim {\n  10% {\n    background-color: rgb(136, 194, 70);\n  }\n  20% {\n    background-color: black;\n  }\n  30% {\n    background-color: rgb(136, 194, 70);\n  }\n  40% {\n    background-color: black;\n  }\n  50% {\n    background-color: rgb(136, 194, 70);\n  }\n  60% {\n    background-color: black;\n  }\n}\n\n.upgrade-broken-window {\n  animation: broken-anim 1s;\n}\n\n@keyframes broken-anim {\n  10% {\n    background-color: rgb(196, 56, 56);\n  }\n  20% {\n    background-color: black;\n  }\n  30% {\n    background-color: rgb(196, 56, 56);\n  }\n  40% {\n    background-color: black;\n  }\n  50% {\n    background-color: rgb(196, 56, 56);\n  }\n  60% {\n    background-color: black;\n  }\n}\n\n.top10-header {\n  font-family: \"Press Start 2P\", system-ui;\n  display: flex;\n  justify-content: center;\n  font-weight: 400;\n  padding-left: 10px;\n  font-size: 14px;\n  z-index: 2;\n}\n\n.top-player-li {\n  z-index: 2;\n  font-size: 12px;\n  justify-content: space-between;\n  border-radius: 8px;\n  padding: 8px 12px;\n  color: black;\n  font-weight: 400;\n}\n\n.top-players-you {\n  z-index: 2;\n  margin-left: 10px;\n  background-color: #00000054;\n  color: rgba(255, 255, 255, 0.781);\n  padding: 0 5px;\n  border-radius: 5px;\n  font-weight: 500;\n}\n\n.aura-container {\n  user-select: none;\n  -webkit-user-select: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: auto;\n  transition: 0.1s ease;\n}\n\n.aura-image {\n  user-select: none;\n  -webkit-user-select: none;\n  display: flex;\n  width: 80%;\n  transform: translateY(-2px);\n  scale: 1;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n@keyframes aura-in {\n  0% {\n    opacity: 0;\n    scale: 0.5;\n  }\n  100% {\n    scale: 1;\n    opacity: 1;\n  }\n}\n\n.tap-circle {\n  height: 32px;\n  width: 32px;\n  align-self: flex-end;\n  background-color: orange;\n  border-radius: 50%;\n}\n\n.settings-container {\n  position: absolute;\n  background-color: #4c6adc;\n  padding: 10px 15px;\n  display: flex;\n  right: 20px;\n  top: 20px;\n  border-radius: 7px;\n  color: rgb(238, 232, 232);\n  font-size: 14px;\n  font-weight: 500;\n  transform-origin: right;\n  animation: showSettings 0.15s ease-out;\n}\n\n@keyframes showSettings {\n  0% {\n    opacity: 0;\n    transform: translateY(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.bottom-buttons {\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n  height: 20%;\n}\n.bottom-item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  width: 100%;\n  height: 100%;\n  background-color: #2b2b2b;\n  color: #d3d3d3;\n}\n.bottom-item-clicked {\n  background-color: #0a0a0a;\n}\n\n.inventory-container {\n  background-color: rgba(0, 0, 0, 0.103);\n  outline: 1px solid rgba(56, 56, 56, 0.5);\n  height: 60vh;\n}\n.add-ui-container {\n  position: relative;\n  margin-bottom: 10px;\n  border-radius: 20px;\n  overflow-y: scroll;\n  background-position: center;\n  background-size: contain;\n}\n\n.inventory-title {\n  background-color: rgba(0, 0, 0, 0.103);\n  color: rgb(194, 194, 194);\n  font-weight: 500;\n  outline: 1px solid rgba(56, 56, 56, 0.5);\n  padding: 5px 8px;\n  border-radius: 20px;\n  min-height: 42px;\n  margin: 5px 0px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.invenory-title-text {\n  margin-left: 10px;\n}\n.intentory-title-quantity {\n  padding: 5px 8px;\n  border-radius: 6px;\n}\n.auras-table {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  overflow: hidden;\n  padding: 10px;\n}\n\n.inventory-table {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 6px;\n  overflow: hidden;\n  padding: 10px;\n}\n.inventory-rarity-circle {\n  height: 10px;\n  width: 10px;\n  top: 7px;\n  right: 7px;\n  position: absolute;\n  border-radius: 6px;\n  rotate: -45deg;\n}\n.table-item {\n  border-radius: 12px;\n  padding: 4px;\n  position: relative;\n  background-size: 150%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  box-shadow: inset 0px -30px 40px 0px rgba(37, 37, 37, 0.349);\n  border: 2px solid rgba(255, 255, 255, 0.267);\n}\n.table-item-name {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 10px;\n  line-height: 1em;\n  font-weight: 700;\n  height: 35px;\n  color: rgba(255, 255, 255, 0.83);\n  background-color: #000000e3;\n  border-radius: 8px;\n  padding: 5px;\n  text-align: center;\n}\n.aura-item-img {\n  border-radius: 8px;\n  padding-bottom: 14px;\n}\n.table-item-img {\n  border-radius: 8px;\n}\n\n.table-item-quantity {\n  color: #e2e2e2d5;\n  display: flex;\n  padding: 5px 8px;\n  font-size: 10px;\n  border-radius: 6px;\n  background-color: #00000094;\n}\n.table-item-cost {\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  color: #f1f1f1d5;\n  padding: 2px 5px;\n  padding-left: 7px;\n  font-size: 10px;\n  border-radius: 12px;\n  background-color: rgb(0, 0, 0);\n}\n\n.active-item-menu {\n  display: inline-block;\n  justify-content: center;\n  position: absolute;\n  width: 100%;\n  left: 0px;\n  bottom: 25px;\n}\n\n.active-item-button {\n  background-color: #000000e5;\n  margin-bottom: 5px;\n  border-radius: 5px;\n  color: beige;\n  width: 100%;\n  height: 50px;\n}\n\n.active-item-description {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  line-height: 1.2em;\n  padding: 12px 12px;\n  background: rgba(0, 0, 0, 0.4);\n  border-radius: 4px;\n}\n\n.mini-game-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.6); /* Затемнение фона */\n  z-index: 10; /* Поверх остальных элементов */\n}\n\n.luck-bonus {\n  color: rgb(122, 122, 122);\n  background-color: rgb(31, 31, 31);\n  transition: background-color 0.2s ease;\n}\n\n.last-spin {\n  background-color: yellowgreen;\n  color: black;\n  font-weight: 600;\n}\n\n.shop-image {\n  display: flex;\n  padding-top: 20px;\n  padding: 15px;\n  background-image: url(\"/public/store-goose.webp\");\n  height: 40vh;\n  outline: 1px solid rgba(56, 56, 56, 0.5);\n  border-radius: 20px;\n  background-size: cover;\n  margin-bottom: 5px;\n  background-position: center;\n  font-size: 14px;\n}\n.pirate-image {\n  display: flex;\n  padding-top: 20px;\n  padding: 15px;\n  background-image: url(\"/public/pirate-character.webp\");\n  height: 40vh;\n  outline: 1px solid rgba(56, 56, 56, 0.5);\n  border-radius: 20px;\n  background-size: cover;\n  margin-bottom: 5px;\n  background-position: center;\n  font-size: 14px;\n}\n.shop-dialog {\n  text-align: center;\n  padding: 10px;\n  border-radius: 8px;\n  position: relative;\n  background-color: white;\n  color: #000;\n  width: 45%;\n  height: fit-content;\n  overflow-wrap: break-word;\n  white-space: normal;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Для красивого вида */\n}\n\n.shop-dialog::after {\n  content: \"\";\n  position: absolute;\n  top: 30%; /* Расположение выше основного блока */\n  right: -5px; /* Смещение вправо */\n  rotate: 45deg;\n  width: 15px;\n  height: 15px;\n  background-color: white;\n}\n\n.shop-items-wrapper {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  flex-direction: column;\n  padding: 10px;\n  font-size: 14px;\n  height: 100%;\n  gap: 10px;\n}\n\n.shop-item-container {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px;\n  padding: 4px;\n  padding-top: 12px;\n  position: relative;\n  flex-shrink: 0;\n  box-shadow: inset 0px 0px 20px 0px rgba(0, 0, 0, 0.5);\n  border: 2px solid rgba(255, 255, 255, 0.267);\n  background-color: #007866;\n  width: 100%;\n  border-radius: 8px;\n}\n\n.shop-item-img {\n  width: 90%;\n  border-radius: 4px;\n}\n.shop-item-title {\n  width: 100%;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.863);\n  border-radius: 4px;\n  padding: 4px;\n  line-height: 1em;\n}\n.shop-item-price {\n  width: 100px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.shop-variants-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n.shop-variants {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n.shop-variants-title {\n  width: 30%;\n}\n\n.variant-selected {\n  outline: 2px solid rgba(255, 255, 255, 0.6);\n}\n.shop-variant {\n  background-color: rgb(31, 31, 31);\n  color: #ebebeb;\n  align-self: flex-end;\n  border: 1px solid;\n  border-color: rgba(56, 56, 56, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  font-size: 14px;\n  text-align: center;\n  padding: 8px;\n  min-width: 60px;\n}\n\n.buy-confirm-window {\n  background-color: #000000fd;\n  padding: 20px;\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 0.5rem;\n  color: rgb(255, 255, 255);\n  text-align: left;\n  align-self: center;\n  position: absolute;\n  bottom: 0;\n  width: 100vw;\n  max-width: 500px;\n  z-index: 4;\n}\n.buy-confirm-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.buy-buttons {\n  background-color: rgb(31, 31, 31);\n  color: #ebebeb;\n  width: 40px;\n  height: 40px;\n  align-self: flex-end;\n  padding: 10px;\n  border: 1px solid;\n  border-color: rgba(56, 56, 56, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 7px;\n  font-size: 18px;\n}\n\n.button-buy {\n  background-color: rgb(113, 120, 218);\n  width: 100%;\n  font-size: 18px;\n  font-weight: 500;\n  border-radius: 8px;\n  height: 55px;\n  color: #000000e1;\n}\n\n.button-buy:disabled {\n  background-color: rgb(57, 58, 75);\n}\n\n.buy-confirm-quantity {\n  width: 40px;\n  text-align: center;\n}\n\n.spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  aspect-ratio: 1/1;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #292929;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.potion-container {\n  position: relative;\n  z-index: 7;\n  width: 0;\n  height: 0;\n}\n\n.potion {\n  transition: transform 0.2s ease;\n}\n\n.city-block-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  font-size: 14px;\n  height: 100%;\n  gap: 10px;\n}\n\n.city-block-container {\n  display: flex;\n  gap: 20px;\n  height: 120px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px;\n  padding-right: 20px;\n  position: relative;\n  flex-shrink: 0;\n  box-shadow: inset 0px -30px 40px 0px rgba(37, 37, 37, 0.349);\n  background-size: cover;\n  background-position: center;\n  background-color: #1b1b1b;\n  width: 100%;\n  border-radius: 8px;\n}\n\n.city-block-title {\n  opacity: 0.9;\n  font-size: 16px;\n  color: #e0e0e0dc;\n  background-color: #0f0f0f;\n  padding: 10px 15px;\n  transform: translateY(30px);\n  border-radius: 0px 35px 10px 0px;\n}\n\n.back-icon {\n  margin-right: 10px;\n  rotate: 90deg;\n}\n\n.city-name {\n  font-size: 16px;\n  padding: 10px;\n  color: rgba(255, 255, 255, 0.4);\n  font-weight: 500;\n  letter-spacing: 0.2em;\n  text-align: center;\n}\n\n.city-name::before {\n  content: \"\";\n  position: absolute;\n  width: 52px;\n  height: 1px;\n  transform: translateX(-70px) translateY(9px);\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.city-name::after {\n  content: \"\";\n  position: absolute;\n  width: 52px;\n  height: 1px;\n  transform: translateX(10px) translateY(9px);\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.blacksmith-items-wrapper {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  overflow: hidden;\n  padding: 10px;\n}\n\n.blacksmith-item {\n  border: 2px solid rgba(255, 255, 255, 0.267);\n  border-radius: 12px;\n  padding: 4px;\n  position: relative;\n  flex-shrink: 0;\n\n  background-color: #1a1a1a;\n}\n.blacksmith-item-img {\n  width: 100%;\n  border-radius: 8px;\n}\n.blacksmith-item-title {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  text-align: center;\n  line-height: 1em;\n  padding: 0 10px;\n  background-color: #363636bb;\n  border-radius: 6px;\n  height: 28px;\n}\n.blacksmith-item-circle {\n  position: absolute;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  right: 6px;\n  top: 6px;\n}\n\n.forge-divider {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: -10px;\n}\n.forge-container {\n  padding: 12px;\n  overflow: scroll;\n}\n\n.forge-top-container {\n  border-radius: 8px;\n  overflow: hidden;\n  background: linear-gradient(\n    90deg,\n    rgb(36, 36, 36) 0%,\n    rgba(51, 51, 51, 0.295) 100%\n  );\n  height: 25%;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  padding: 6px;\n}\n.forge-title-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.forge-title {\n  font-size: 18px;\n  text-align: center;\n  max-width: 85%;\n  margin-bottom: 10px;\n}\n.forge-description {\n  font-size: 14px;\n  color: rgb(140, 207, 95);\n  text-align: center;\n  max-width: 85%;\n}\n.forge-image {\n  height: 100%;\n  border-radius: 8px;\n}\n\n.forge-need-wrapper {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n  overflow: hidden;\n  background-color: #000000;\n}\n\n.forge-need-container {\n  position: relative;\n  background-color: #222222;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px;\n  gap: 4px;\n  font-size: 10px;\n}\n.forge-need-img {\n  width: 100%;\n  border-radius: 6px;\n  background-color: #3d3d3d;\n}\n.forge-need-title {\n  text-align: center;\n  height: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.add-ui-forge {\n  margin-bottom: 20px;\n  border-radius: 20px;\n  height: 100%;\n  overflow: hidden;\n}\n\n.forge-item-quantity {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  font-size: 12px;\n  min-width: 16px;\n  padding: 0 4px;\n  height: 16px;\n  background-color: yellow;\n  color: black;\n  border-radius: 4px;\n}\n\n.forge-button {\n  color: \"white\";\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  align-items: center;\n  border-radius: 8px;\n  gap: 10px;\n  color: rgba(22, 22, 22, 0.911);\n  overflow: hidden;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 10px 16px;\n  margin-top: 24px;\n  background-color: yellow;\n}\n\n.forge-button:disabled {\n  color: \"white\";\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  align-items: center;\n  border-radius: 8px;\n  gap: 10px;\n  color: rgba(22, 22, 22, 0.911);\n  overflow: hidden;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 10px 16px;\n  margin-top: 24px;\n  background-color: rgb(63, 63, 63);\n}\n\n.crafting-anim {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 40px;\n  background-color: #000000e3;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  z-index: 4;\n}\n\n.zoom-item-wrapper {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: fit-content;\n  width: 80%;\n  max-width: 400px;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.zoom-item-container {\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  border: #3d3d3d 1px solid;\n  border-radius: 12px;\n  padding: 16px;\n  gap: 10px;\n  box-shadow: inset 0px 0 24px 12px rgba(0, 0, 0, 0.3);\n  border: 3px solid rgba(0, 0, 0, 0.6);\n  animation: glossy 0.2s ease-out;\n  margin-bottom: 16px;\n}\n\n.zoom-item-container::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 0.3),\n    rgba(0, 0, 0, 0) 70%\n  );\n  z-index: -1;\n}\n@keyframes glossy {\n  0% {\n    box-shadow: inset 0px 0px 5px 0px rgba(255, 255, 255, 0.2);\n    transform: rotateX(20deg);\n  }\n  100% {\n    box-shadow: inset 0px 120px 5px 0px rgba(255, 255, 255, 0.2);\n    transform: rotateX(00deg);\n  }\n}\n\n.zoom-item-title {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  line-height: 1em;\n  font-weight: 600;\n  height: 35px;\n  padding: 5px 10px;\n  text-align: center;\n  width: 100%;\n}\n.zoom-item-description {\n  color: yellow;\n  background-color: rgba(0, 0, 0, 0.227);\n  width: 100%;\n  text-align: center;\n  padding: 10px 15px;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.zoom-item-quantity {\n  position: absolute;\n  text-align: end;\n  color: #e2e2e2d5;\n  padding: 5px 8px;\n  font-size: 12px;\n  border-radius: 6px 6px 0 0;\n  background-color: #464646e7;\n  top: -26px;\n  left: 10px;\n}\n.zoom-item-rarity {\n  position: absolute;\n  text-align: end;\n  color: #000000;\n  padding: 5px 8px;\n  font-size: 12px;\n  border-radius: 6px 6px 0 0;\n  top: -27px;\n  right: 10px;\n}\n.zoom-item-img {\n  border-radius: 8px;\n  width: 100%;\n  margin-bottom: 20px;\n  transition: 0.2s ease;\n}\n\n.upgrading-img-anim {\n  animation: upgrading-scale 3s ease-in-out,\n    upgrading-shake 0.2s linear infinite;\n}\n\n@keyframes upgrading-scale {\n  0% {\n    scale: 1;\n  }\n  95% {\n    scale: 0.8;\n  }\n  100% {\n    scale: 1;\n  }\n}\n\n@keyframes upgrading-shake {\n  0% {\n    rotate: -3deg;\n  }\n  25% {\n    rotate: 2deg;\n  }\n  50% {\n    rotate: -1deg;\n  }\n  75% {\n    rotate: 4deg;\n  }\n  100% {\n    rotate: 0deg;\n  }\n}\n\n.zoom-item-button {\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  background-color: rgb(223, 238, 18);\n  color: rgb(0, 0, 0);\n  padding: 6px 10px;\n  z-index: 5;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  line-height: 1em;\n  text-align: left;\n  height: 48px;\n}\n.zoom-item-button-center {\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  background-color: rgb(223, 238, 18);\n  color: rgb(0, 0, 0);\n  padding: 6px 10px;\n  z-index: 5;\n  width: 100%;\n  align-items: center;\n  line-height: 1em;\n  height: 48px;\n}\n\n.zoom-item-button:disabled {\n  background-color: #979797;\n}\n\n.shimmer {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 8px;\n  background: linear-gradient(\n    90deg,\n    #ffffff3d 0%,\n    #b8b8b8 25%,\n    #ffffff 50%,\n    #a8a8a8 75%,\n    #ffffff3d 100%\n  );\n  opacity: 0.3;\n  background-size: 200% 100%;\n  animation: shimmer 1.5s linear infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.equipped-items-container {\n  height: 60px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px;\n  margin-bottom: 10px;\n  padding: 5px;\n}\n.wearing-text {\n  display: flex;\n  justify-content: center;\n  width: 40%;\n  color: #ffffffa4;\n}\n.equipped-item {\n  height: 50px;\n  border: 1px solid rgb(48, 48, 48);\n  border-radius: 8px;\n  aspect-ratio: 1/1;\n  background-color: #0000009c;\n  background-size: cover;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.623);\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.items-stack-container {\n  left: 0;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 4px;\n  width: 50px;\n  top: 15%;\n  background-color: #51af34;\n  border-radius: 0px 12px 12px 0px;\n  border: 2px solid rgba(255, 255, 255, 0.267);\n}\n\n.items-stack-quantity {\n  font-weight: 600;\n  font-size: 12px;\n  color: #ffffffe8;\n  white-space: nowrap;\n}\n\n.button-autospin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 25%; /* У вас уже указано дважды, оставил один */\n  font-size: 18px;\n  font-weight: 500;\n  border-radius: 8px;\n  height: 100%;\n  background-color: rgb(223, 223, 223);\n  background-size: 200% 100%;\n  color: #000000;\n  scale: 1;\n  transition: background-color 0.2s ease;\n}\n\n.gradient-flow {\n  background-color: rgb(176, 221, 51);\n}\n\n.dungeon-container {\n  position: relative;\n  margin-bottom: 10px;\n  border-radius: 20px;\n  background-position: center;\n  background-size: contain;\n  background-color: rgba(0, 0, 0, 0.103);\n  outline: 1px solid rgba(56, 56, 56, 0.5);\n  width: 100%;\n  aspect-ratio: 1/1;\n}\n\n.dropdown-container {\n  position: relative;\n}\n\n.dropdown {\n  padding: 4px 15px;\n  font-size: 16px;\n  background-color: #3e434d;\n  color: #ddd;\n  border: none;\n  border-radius: 30px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n  padding-right: 30px; /* Увеличиваем отступ для стрелки */\n  appearance: none; /* Убираем стандартную стрелку */\n}\n\n.dropdown:focus {\n  outline: none;\n  background-color: #4a4f5c;\n  color: #fff;\n}\n\n.dropdown option {\n  padding: 10px;\n  font-size: 16px;\n  background-color: #3e434d;\n  color: #ddd;\n}\n\n.dropdown option:hover {\n  background-color: #4a4f5c;\n}\n\n/* Кастомная стрелка */\n.dropdown-container::after {\n  content: \"▼\"; /* Стрелка вниз */\n  position: absolute;\n  right: 10px; /* Отступ от правого края */\n  top: 50%;\n  transform: translateY(-50%); /* Центрирование по вертикали */\n  font-size: 12px;\n  color: #ddd;\n  pointer-events: none; /* Стрелка не мешает кликам */\n}\n\n.request-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgb(62, 66, 71);\n  padding: 4px;\n  width: 100%;\n  padding-left: 12px;\n  border-radius: 12px;\n}\n\n.status-text {\n  font-size: 12px;\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n}\n.online {\n  color: rgb(131, 221, 89);\n}\n\n.online::before {\n  content: \"\";\n  position: absolute;\n  transform: translateX(-12px);\n  height: 10px;\n  width: 10px;\n  border-radius: 6px;\n  background-color: rgb(131, 221, 89);\n}\n.offline {\n  color: rgb(121, 121, 121);\n}\n.offline::before {\n  content: \"\";\n  position: absolute;\n  transform: translateX(-12px);\n  height: 10px;\n  width: 10px;\n  border-radius: 6px;\n  background-color: rgb(121, 121, 121);\n}\n\n.reward-container {\n  position: absolute;\n  margin: auto;\n  top: 100px;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: fit-content;\n  width: 80%;\n  max-width: 400px;\n  z-index: 5;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgb(108, 56, 192);\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.reward-window {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  overflow: hidden;\n  padding: 10px;\n}\n.reward-item-container {\n  position: relative;\n  background-color: #2b2331;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px;\n  gap: 4px;\n  font-size: 14px;\n  z-index: 3;\n}\n.reward-today {\n  outline: 4px solid rgba(255, 255, 0, 0.829);\n}\n.reward-img {\n  width: 100%;\n  aspect-ratio: 1/1;\n}\n\n.reward-top-image {\n  position: absolute;\n  bottom: 75%;\n  width: 100%;\n  opacity: 1;\n  z-index: 1;\n  animation: gooseShow 2s ease;\n}\n\n@keyframes gooseShow {\n  0% {\n    bottom: 60%;\n    opacity: 0;\n  }\n  50% {\n    bottom: 60%;\n    opacity: 0;\n  }\n  100% {\n    bottom: 75%;\n    opacity: 1;\n  }\n}\n.reward-backscreen {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: #000000c2;\n  z-index: 10;\n}\n\n.header-text {\n  font-size: 18px;\n  font-weight: 700;\n  color: rgb(255, 238, 0);\n  background-color: rgb(36, 36, 36);\n  padding: 4px 24px;\n  rotate: -3deg;\n  margin-bottom: 5px;\n  z-index: 2;\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
